<template>
<div>

	<!-- page-heading -->
	<page-heading show="false" showBack="false" pageTitle="HEADER-PLACEMENTS"></page-heading>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<div class="col-main">

			<!-- Message Box for "Industriepartner" users only | no pages available -->
			<alert :closable="true" v-if="catalogPages.length == 0">
				<lang labelKey="MSG-INDUSTRY_PARTNER-NO_PAGES_FOR_APPROVEMENT_AVAILABLE"></lang>
			</alert>

			<!-- Message Box for "Industriepartner" users only | pages available, show info -->
			<alert type="info" :closable="true" class="infoSpecial" v-if="catalogPages.length > 0">
				<!-- <lang labelKey="MY_INDIVIDUALISATIONS-INFO_TEXT"></lang> -->
				<div v-html="infoTextIndustriepartner"></div>
			</alert>

			<tabs type="boxed" size="normal" v-if="catalogPages.length > 0">

				<!-- <tab-item v-for="(catalogPage, catalogPageIndex) in catalogPages" :label="catalogPage.name" :key="catalogPage.id" v-if="catalogPageIndex % 2==0"> -->
				<tab-item v-for="(catalogPage, catalogPageIndex) in catalogPagesComputed" :label="catalogPage.name" :key="catalogPage.id">


					<div class="columns">

						<div class="column is-10">

							<template v-for="(catalogPageVariant, variantIndex) in catalogPage.catalogPageVariants">

								<div class="columns is-multiline" v-if="catalogPage.status != catalogPageStatus.REVISED.id">

									<div class="column" :key="catalogPageVariant.id" v-if="catalogPageVariant.status==catalogPageVariantStatus.APPROVED.id">

										<div class="variantWrapper">

											<div class="variantImageWrapper">

												<lightbox :src="getCatalogPageVariantImage(catalogPageVariant.preview)">

													<div class="lazyImg lazy-img-fadein" v-lazy:background-image="getCatalogPageVariantImage(catalogPageVariant.preview)">

													</div>

												</lightbox>

											</div>

											<div class="variantOptions is-clearfix">


												<a :href="getCatalogPageVariantDownloadURL(catalogPageVariant.preview)" download class="button is-normal is-pulled-left">
													<span class="icon is-small">
														<i class="icon-ak-download"></i>
													</span> Download
												</a>

												<div class="radioButtonContainer is-pulled-right">

													<input type="radio" :id="variantIndex" name="selector" checked="true">
													<label :for="variantIndex">ausgewählt</label>
													<div class="check"></div>

												</div>

											</div>

										</div>

									</div>

								</div>


								<div v-else-if="catalogPageVariant.status != 84" class="columns is-multiline">

									<div class="column" :key="catalogPageVariant.id">

										<div class="variantWrapper">

											<div class="variantImageWrapper">

												<lightbox class="variantImageWrapper" :src="getCatalogPageVariantImage(catalogPageVariant.preview)">

													<div class="lazyImg lazy-img-fadein" v-lazy:background-image="getCatalogPageVariantImage(catalogPageVariant.preview)">

													</div>

												</lightbox>

											</div>

											<div class="variantOptions is-clearfix">

												<div class="radioButtonContainer is-pulled-right" @click="changePickedVariant(catalogPageIndex, variantIndex)">

													<input type="radio" :id="catalogPageIndex+'-'+variantIndex" name="selector">
													<label :for="catalogPageIndex+'-'+variantIndex">auswählen</label>
													<div class="check"></div>

												</div>

												<a :href="getCatalogPageVariantDownloadURL(catalogPageVariant.preview)" download class="button is-normal is-pulled-left">
													<span class="icon is-small"><i class="icon-ak-download"></i></span> Download
												</a>

											</div>

										</div>

									</div>

								</div>

							</template>

						</div>


						<div class="column has-text-right">

							<!-- double page is approved button -->
							<template v-if="isCatalogPageApproved(catalogPageIndex) == true">
								<custom-button type="approve" :loading="isApproving" class="is-disabled" icon="icon-ak-freigaben" name="INDUSTRY_VIEW-BTN-PRINT_APPROVED"></custom-button>
							</template>

							<!-- default button -->
							<template v-else>
								<custom-button type="approve" icon="icon-ak-freigaben" name="INDUSTRY_VIEW-BTN-PRINT_APPROVEMENT" @click.native="approveCatalogPage(catalogPageIndex)"></custom-button>
							</template>

						</div>

					</div>

					<!-- COMMENTS -->
					<comments :showInput="!isCatalogPageApproved(catalogPageIndex)" :threadID.sync="catalogPage.thread" :api="'catalogPage/'+catalogPage.id"></comments>

				</tab-item>


			</tabs>

		</div>

	</template>

</div>
</template>


<script>
import comments from '../../utils/incl-comments';

export default {

	components: {
        comments
	},


	data() {
		return {
			isLoading: true,
			catalogPage: false,
			catalogPages: [],
			catalog: [],
			catalogPageElements: [],
			placements: [],
			catalogPagesApproved: false,
			pickedVariant: null,
			isPrintApproved: []
		}
	},

    computed: {

			catalogPagesComputed() {

				// return this.catalogPages.filter((p, index) => index % 2 == 0);
				return this.catalogPages;
				
			},

			catalogPageImage() {

				if(this.catalogPage.catalogPageVariants.length == 0) {
					return "";
				}
				var url = this.catalogPage.preview.path + '/thumb/' + this.catalogPage.preview.filename;
				return this.$config.assets + url.substr(0, url.lastIndexOf(".")) + ".jpg";

	    },

			catalogPageElementStatus() {
				return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_ELEMENT_STATUS');
			},

			catalogPageStatus() {
				return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_STATUS');
			},

			catalogPageVariantStatus() {
				return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_VARIANT_STATUS');
			},

			infoTextIndustriepartner() {
				return this.nl2br(this.$t('MSG-BOX-INDUSTRIEPARTNER-PRINT_APPROVEMENTS'))
			},

	},

	created() {

		this.fetchCatalogPages();

	},

  updated() {

  },

	mounted() {

	},


	methods: {

		isCatalogPageApproved(catalogPageIndex) {

			return this.catalogPages[catalogPageIndex].status == this.catalogPageStatus.APPROVED.id || this.catalogPages[catalogPageIndex].status == this.catalogPageStatus.PRINT_APPROVED.id;

		},

		getPreview(preview, type) {

			if(preview == null) {
				return '';
			}

			if(type == 'voucher') {
				var url = preview.path + '/thumb/' + preview.filename;
				return this.$config.assets + url.substr(0, url.lastIndexOf(".")) + ".jpg";
			} else {
				var url = preview.path + '/thumb/' + preview.filename;
				return this.$config.assets + url.substr(0, url.lastIndexOf(".")) + ".jpg";
			}

		},


		getCatalogPageVariantImage(preview) {

			return this.$config.assets + preview.path + '/' + preview.filename;

		},

		getCatalogPageVariantDownloadURL(preview) {

			return this.$config.assets + preview.path + '/' + preview.filename.substr(0, preview.filename.lastIndexOf(".")) + ".pdf";

		},

		getPdfDownloadUrl(preview) {

			if(preview && preview.path && preview.filename) {

				var asset = this.$config.assets + preview.path + '/' + preview.filename;
				return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";
			}

		},

		changePickedVariant(catalogPageIndex, variantIndex) {

			this.pickedVariant = variantIndex;

			// set this variant to status "approved"
			this.catalogPages[catalogPageIndex].catalogPageVariants[this.pickedVariant].status = this.catalogPageVariantStatus.APPROVED.id;

			var self = this;
			var	url = this.$config.api + 'catalogPage';

			this.axios.put(url, this.catalogPages);

		},

		approveCatalogPage(catalogPageIndex) {

			// check if a variant was picked
			if(this.pickedVariant == null) {
				this.$notify.open({content: this.$t('MSG-ERROR-INDUSTRY_USER-PLEASE_APPROVE_VARIANT'), type: 'warning'});
				return;
			}

			// set this variant to status "approved"
			this.catalogPages[catalogPageIndex].catalogPageVariants[this.pickedVariant].status = this.catalogPageVariantStatus.APPROVED.id;

			// set the status of the catalogPage to "approved" (term 14)
			this.catalogPages[catalogPageIndex].status = this.catalogPageStatus.APPROVED.id

			// find corresponding second page and change the status
			this._changeStatusSecondPage(this.catalogPages[catalogPageIndex].sortorder);

			var self = this;
			var	url = this.$config.api + 'catalogPage';

			// this.axios.put(url, this.catalogPage)
			this.axios.put(url, this.catalogPages)
				.then(function(res) {
					self.catalogPagesApproved = true;
					self.isSaving = false;
					self.$notify.success({content: self.$t('MSG-APPROVEMENT_GRANTED')});
				})
				.catch(function(err) {
					self.Saving = false;
					console.log(err);
				});

		},

		approvePlacement(el) {

			var saveElement = el;
			saveElement.status = this.catalogPageElementStatus.PRINT_APPROVED.id;

            var self = this,
				url = this.$config.api + 'catalogPageElement/'+el.id;

			this.axios.put(url, saveElement)
				.then(function(res) {
					self.isPrintApproved.push(el.id);
					self.isSaving = false;
					self.$notify.success({content: self.$t('MSG-APPROVEMENT_GRANTED')});
				})
				.catch(function(err) {
					self.Saving = false;
					console.log(err);
				});


		},

		_changeStatusSecondPage(sortorder) {

			this.catalogPages.forEach(function(catalogPage, index) {

				if(catalogPage.sortorder == (parseInt(sortorder) + 1)) {
					catalogPage.status = this.catalogPageStatus.APPROVED.id
				}

			}, this);

		},


		fetchCatalogPages() {

			var self = this;
			var url = this.$config.api + 'catalogPage?include=catalogPage.catalog,catalogPage.catalogPageElements,catalogPage.preview,catalogPage.catalogPageVariants,catalogPageVariant.preview,preview.siteCatalogAsset&filters[catalog.isActive]=1&filters[status]='+this.catalogPageStatus.REVISED.id+','+this.catalogPageStatus.APPROVED.id+','+this.catalogPageStatus.PRINT_APPROVED.id+'&filters[manufacturer]='+this.$store.getters.getUser.manufacturer.id;

      this.axios.get(url).then((res) => {
				console.log("RES: ", res.data.catalogPage);
				this.isLoading = false;
				this.catalogPages = res.data.catalogPage;
			})
			.catch((err) => {
				this.isLoading = false;
				// console.log(err);
			});

		},


	}

}
</script>




<style lang="scss" scoped>

    @import '../../../assets/css/variables.scss';

	.variantStatus-DEFAULT {
		background: $statusCreated !important;
	}
	.variantStatus-SELECTED {
		background: $statusApproved !important;
	}
	.variantStatus-APPROVED {
		background: $statusPrintApproved !important;
	}



	input[type=radio]:checked ~ .check {
		border: 5px solid #23D161;
	}
	input[type=radio]:checked ~ .check::before{
		background: #23D161;
	}
	input[type=radio]:checked ~ label{
		color: #23D161;
	}


</style>


<style scoped>

	.radioButtonContainer {
		position: relative;
		text-align: right;
	}
	.radioButtonContainer input[type=radio]{
		position: absolute;
		visibility: hidden;
	}
	.radioButtonContainer label {
		display: block;
		position: relative;
		font-weight: 300;
		font-size: 1.15em;
		/*padding: 25px 25px 25px 80px;*/
		padding: 3px 0 0 50px;
		margin: 0;
		/*margin: 10px auto;*/
		height: 30px;
		z-index: 9;
		cursor: pointer;
		-webkit-transition: all 0.25s linear;
	}
	.radioButtonContainer:hover label {
	    /*color: #000;*/
		color: #23D161;
	}
	.radioButtonContainer .check {
		display: block;
		position: absolute;
		border: 4px solid #AAAAAA;
		border-radius: 100%;
		/*
		height: 21px;
		width: 21px;
		top: 5px;
		left: 20px;
		*/

		height: 17px;
		width: 17px;
		top: 7px;
		left: 26px;
		z-index: 5;
		transition: border .25s linear;
		-webkit-transition: border .25s linear;
	}
	.radioButtonContainer:hover .check {
		/*border: 5px solid #000;*/
		border: 5px solid #23D161;
	}

	.radioButtonContainer .check::before {
		display: block;
		position: absolute;
		content: '';
		border-radius: 100%;
		height: 9px;
		width: 9px;
		top: 1px;
		left: 1px;
		margin: auto;
		transition: background 0.25s linear;
		-webkit-transition: background 0.25s linear;
	}

	/*
	input[type=radio]:checked ~ .check {
		border: 5px solid #0DFF92;
	}
	input[type=radio]:checked ~ .check::before{
		background: #0DFF92;
	}
	input[type=radio]:checked ~ label{
		color: #0DFF92;
	}
	*/



	.variantWrapper {
		background: #fafafa;
		border: 1px solid #eee;
		border-radius: 4px;
	}
	.variantImageWrapper {
		text-align: center;
		/*height: 11.1vw;*/
		height: 34vw;
		cursor: pointer;
	}

	.variantImageWrapper .lazyImg {
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		height: 100%;
	}
	.variantOptions {
		border-top: 1px solid #ddd;
		background: #fcfcfc;
		padding: 8px 10px;
	}



	.catalogPage {
		text-align: center;
	}
	.catalogPage img {
		min-width: 250px;
		width: 100%;
	    max-width: 2048px;
		margin: 0 auto;
	}
	.lazy-img-fadein[lazy=loading] {
	    background-position: 50% 20% !important;
	    background-size: 10% !important;
	}
	.placement {
		min-width: 150px;
		width: 25vmin;
	}
	.commentsWrapper {
		max-width: 60%;
	}
	.voucherPreview { width: 100%; }
	.placementPreview { width: 100%; }
</style>


<style>
	.tabs ul.tab-list li a span {
	    white-space: nowrap !important;
	    overflow: hidden !important;
	    text-overflow: ellipsis !important;
	    max-width: 180px !important;
	}
	.sideButtons {
		margin-bottom: 15px;
	}
	.sideButtons button {
		margin: 0 0 5px 0;
	}
</style>
